import { gql } from '@apollo/client';
import { USER_FRAGMENT } from '../user/fragments';

export const SIGN_IN_GOOGLE_CLIENT = gql`
  ${USER_FRAGMENT}

  mutation SignInGoogleClient($clientId: String!, $credential: String!) {
    signInGoogleClient(clientId: $clientId, credential: $credential) {
      __typename
      ... on SignInClient {
        message
        accessToken
        refreshToken
        user {
          ...UserFragment
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const SIGN_OUT_CLIENT = gql`
  mutation signOutClient($deviceId: String, $logoutAllDevices: Boolean) {
    signOutClient(deviceId: $deviceId, logoutAllDevices: $logoutAllDevices) {
      ... on SignOutClient {
        message
      }
      ... on Error {
        message
      }
    }
  }
`;

export const AUTHENTICATE_WITH_ACCESS_LINK_TOKEN = gql`
  mutation ExchangeAccessLinkToken($token: String!) {
    exchangeAccessLinkToken(token: $token) {
      ... on ExchangeAccessLinkToken {
        message
        version
        accessToken
        refreshToken
        tokenType
        alreadyVerified
      }
      ... on Error {
        message
      }
    }
  }
`;

export const EXCHANGE_CLIENT_UPDATE_TOKEN = gql`
  mutation ExchangeClientUpdateToken($token: String!) {
    exchangeClientUpdateToken(token: $token) {
      ... on ExchangeClientUpdateToken {
        message
        version
        accessToken
        refreshToken
        user {
          id
          firstName
          lastName
          email
          phone
          timeZone
          locale
        }
        account {
          id
          companyName
          billingInfo {
            address1
            address2
            city
            state
            zip
            country
          }
        }
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const EXCHANGE_MAGIC_LINK_TOKEN = gql`
  mutation ExchangeMagicLinkToken($token: String!) {
    exchangeMagicLinkToken(token: $token) {
      __typename
      ... on ExchangeMagicLinkToken {
        message
        accessToken
        refreshToken
        redirectPath
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($data: ResetUserPasswordInput!) {
    resetUserPassword(data: $data) {
      ... on ResetUserPassword {
        message
      }
      ... on Error {
        errorCode
        message
      }
    }
  }
`;

export const SIGN_IN_CLIENT_BY_TOKEN = gql`
  ${USER_FRAGMENT}

  mutation SignInClientByToken($data: CheckResetTokenInput!) {
    signInClientByToken(data: $data) {
      __typename
      ... on SignInClient {
        message
        version
        accessToken
        refreshToken
        user {
          ...UserFragment
        }
        account {
          id
        }
      }
      ... on Error {
        __typename
        errorCode
        message
      }
    }
  }
`;

export const REFRESH_ACCESS_TOKEN = gql`
  ${USER_FRAGMENT}

  mutation RefreshAccessToken($data: RefreshAccessTokenInput!) {
    refreshAccessToken(data: $data) {
      ... on RefreshAccessToken {
        message
        accessToken
        refreshToken
        user {
          ...UserFragment
        }
      }
      ... on Error {
        message
        errorCode
      }
    }
  }
`;
